import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { FcDeadlineViolationReasonInputModule } from '@core/components/fc-input/search-one/fc-deadline-violation-reason-input/fc-deadline-violation-reason-input.module';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { TabNewDeadlineComponent } from './tab-new-deadline.component';

@NgModule({
  entryComponents: [
    TabNewDeadlineComponent
  ],
  declarations: [
    TabNewDeadlineComponent
  ],
  imports: [
    PipesModule,
    MatIconModule,
    TranslateModule,
    FuseSharedModule,
    DisclaimerModule,
    FcDeadlineViolationReasonInputModule
  ],
  exports: [
    TabNewDeadlineComponent
  ],
})
export class TabNewDeadlineModule { }
